/* ScandLights: small vanilla replacements for the live theme's jQuery/slick behaviour.
   Menu drawer, sticky add-to-cart, "slick-lite" sliders (same DOM/classes slick produces), variant radios. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const body = document.body;

  /* rich text, as live's theme script does it: links without images get the text-link style, tables get a scroll wrapper */
  $$('.rte a').forEach((a) => { if (!a.querySelector('img')) a.classList.add('text-link'); });
  $$('.rte table').forEach((t) => { const w = document.createElement('div'); w.className = 'table-wrap'; t.parentNode.insertBefore(w, t); w.appendChild(t); });

  /* links to other sites open in a new tab (live theme script does the same) */
  [...document.links].forEach((a) => { if (a.hostname && a.hostname !== location.hostname) { a.target = '_blank'; a.rel = 'noreferrer noopener'; } });

  /* menu drawer: same classes Debutify sets when it opens */
  const nav = $('#NavDrawer');
  const openNav = (e) => { e && e.preventDefault(); if (!nav) return; body.classList.add('js-drawer-open', 'js-drawer-open-left'); nav.classList.add('js-drawer-open'); nav.setAttribute('aria-hidden', 'false'); };
  const closeNav = () => { if (!nav) return; body.classList.remove('js-drawer-open', 'js-drawer-open-left'); nav.classList.remove('js-drawer-open'); nav.setAttribute('aria-hidden', 'true'); };
  $$('.js-drawer-open-button-left').forEach((b) => b.addEventListener('click', openNav));
  $$('.js-drawer-close').forEach((b) => b.addEventListener('click', closeNav));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeNav(); });

  /* slick-lite: builds .slick-list > .slick-track like slick so the harvested styles apply */
  function slider(el) {
    const show = +el.dataset.show || 1;
    const slides = [...el.children];
    if (!slides.length) return null;
    el.classList.add('slick-initialized', 'slick-slider');
    const list = document.createElement('div'); list.className = 'slick-list draggable';
    const track = document.createElement('div'); track.className = 'slick-track'; track.style.opacity = '1';
    slides.forEach((s, i) => { s.classList.add('slick-slide'); s.dataset.slickIndex = i; track.appendChild(s); });
    list.appendChild(track); el.appendChild(list);
    let idx = 0;
    // slick maths: slide pitch = ceil(list content width / slidesToShow); slide width = pitch - its own margins
    const width = () => { const cs = getComputedStyle(list); return Math.ceil((list.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)) / show); };
    function go(i, animate = true) {
      idx = Math.max(0, Math.min(i, Math.max(0, slides.length - show)));
      track.style.transition = animate ? 'transform 300ms ease' : 'none';
      track.style.transform = `translate3d(${-idx * width()}px, 0px, 0px)`;
      slides.forEach((s, j) => {
        const active = j >= idx && j < idx + show;
        s.classList.toggle('slick-current', j === idx); s.classList.toggle('slick-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      el.dispatchEvent(new CustomEvent('sl:slide', { detail: idx }));
    }
    function layout() {
      const w = width(); const sc = getComputedStyle(slides[0]);
      const extra = parseFloat(sc.marginLeft) + parseFloat(sc.marginRight);
      slides.forEach((s) => { s.style.width = (w - extra) + 'px'; });
      track.style.width = Math.ceil(w * slides.length) + 'px'; go(idx, false);
    }
    // touch swipe
    let x0 = null;
    list.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    list.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); x0 = null; }, { passive: true });
    window.addEventListener('resize', layout);
    layout();
    return { go, get index() { return idx; }, slides };
  }

  /* one buy box per [data-section-type="product-template"] (product page, or several featured products on home) */
  const fmt = (cents) => (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : `${Math.round(cents / 100)} kr`;
  $$('[data-section-type="product-template"]').forEach((root) => {
    const main = $('[data-sl-slider="main"]', root);
    const thumbsEl = $('[data-sl-slider="thumbs"]', root);
    const mainSlider = main ? slider(main) : null;
    const thumbSlider = thumbsEl ? slider(thumbsEl) : null;
    if (mainSlider && thumbsEl) {
      $$('[data-thumb-index]', thumbsEl).forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); mainSlider.go(+a.dataset.thumbIndex); }));
      main.addEventListener('sl:slide', (e) => {
        const i = e.detail;
        $$('[data-thumb-index]', thumbsEl).forEach((a) => a.classList.toggle('active-thumb', +a.dataset.thumbIndex === i));
        if (thumbSlider && (i < thumbSlider.index || i >= thumbSlider.index + 5)) thumbSlider.go(i - 2);
      });
    }

    /* variant radios/dropdowns -> hidden select (Kaching + Dawn's product-form read it), price, label, url, image */
    const json = $(`[data-sl-product-json="${root.dataset.sectionId}"]`);
    const product = json ? JSON.parse(json.textContent) : null;
    const moneyEl = $(`[data-sl-money="${root.dataset.sectionId}"]`);
    const money = moneyEl ? JSON.parse(moneyEl.textContent) : {};
    const pm = (v, i) => (money[v.id] && money[v.id][i]) || fmt(i ? v.compare_at_price || 0 : v.price);   // the store's own money format
    const form = $('form.product-single__form', root);
    const picker = $('.sl-variant-picker', root);
    if (!product || !form || !picker) return;
    const select = $('select[name="id"]', form);
    const isPage = !root.className.trim(); // featured products carry their section style class
    picker.addEventListener('change', (e) => {
      if (!e.target.classList.contains('js-single-option-selector')) return;
      const opts = product.options.map((_, i) => { const c = picker.querySelector(`input[name="option${i + 1}"]:checked, select[name="option${i + 1}"]`); return c ? c.value : null; });
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) return;
      select.value = v.id; select.dispatchEvent(new Event('change', { bubbles: true }));
      $$('.variant-label-option-value', picker).forEach((s, i) => { s.textContent = opts[i]; });
      const p = $('[data-sl-price] .money', root); if (p) p.textContent = pm(v, 0);
      const c = $('[data-sl-compare]', root); if (c) { c.style.display = v.compare_at_price > v.price ? '' : 'none'; c.querySelector('.money').textContent = pm(v, 1); }
      $$('a.product-single__full-details', root).forEach((a) => { a.href = `/products/${product.handle}?variant=${v.id}`; });
      if (isPage) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      if (v.featured_media && mainSlider) { const i = product.media.findIndex((m) => m.id === v.featured_media.id); if (i > -1) mainSlider.go(i); }
      syncSticky(v);
    });

    /* sticky bar dropdown <-> main picker (live: syncedProductVariant): same variant, thumbnail and price in both */
    const sticky = $('[data-sl-sticky-select]', root);
    function syncSticky(v) {
      if (!sticky) return;
      sticky.value = v.id;
      const o = sticky.selectedOptions[0], img = $('.image-sticky_addtocart', root);
      if (o && img && o.dataset.image) img.src = o.dataset.image;
      const p = $('.total-sticky-price .money', root); if (p) p.textContent = pm(v, 0);
      const c = $('.total-sticky-compare-price', root);
      if (c) { c.style.display = v.compare_at_price > v.price ? 'inline-block' : 'none'; c.querySelector('.money').textContent = pm(v, 1); }
    }
    if (sticky) sticky.addEventListener('change', () => {
      const v = product.variants.find((x) => String(x.id) === sticky.value);
      if (!v) return;
      let last;
      v.options.forEach((val, i) => {
        const el = $$(`[name="option${i + 1}"]`, picker).find((x) => x.tagName === 'SELECT' || x.value === val);
        if (!el) return;
        if (el.tagName === 'SELECT') el.value = val; else el.checked = true;
        last = el;
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* zoom icon: toggles an in-place magnifier on the image (live: jquery.zoom on the data-zoom url, image_zoom mode) */
  $$('.btn-zoom').forEach((btn) => btn.addEventListener('click', () => {
    const wrap = btn.previousElementSibling;
    if (!wrap || !wrap.dataset.zoom) return;
    const on = wrap.querySelector('.zoomImg');
    if (on) { on.remove(); wrap.classList.remove('zoom-active'); return; }
    const img = new Image(); img.className = 'zoomImg'; img.alt = ''; img.role = 'presentation';
    img.style.cssText = 'position:absolute;top:0;left:0;opacity:0;border:none;max-width:none;max-height:none;transition:opacity .12s';
    const move = (x, y) => {
      const r = wrap.getBoundingClientRect();
      const fx = Math.min(1, Math.max(0, (x - r.left) / r.width)); const fy = Math.min(1, Math.max(0, (y - r.top) / r.height));
      img.style.left = `${-(img.width - r.width) * fx}px`; img.style.top = `${-(img.height - r.height) * fy}px`;
    };
    img.onload = () => { wrap.appendChild(img); wrap.classList.add('zoom-active'); img.style.opacity = '1'; const r = wrap.getBoundingClientRect(); move(r.left + r.width / 2, r.top + r.height / 2); };
    img.src = wrap.dataset.zoom;
    wrap.slZoomMove = move;
    if (!wrap.dataset.zoomBound) {
      wrap.dataset.zoomBound = '1';
      wrap.addEventListener('mousemove', (e) => { if (wrap.querySelector('.zoomImg')) wrap.slZoomMove(e.clientX, e.clientY); });
      wrap.addEventListener('touchmove', (e) => { if (!wrap.querySelector('.zoomImg')) return; e.preventDefault(); wrap.slZoomMove(e.touches[0].clientX, e.touches[0].clientY); }, { passive: false });
    }
  }));

  /* sticky columns (live theme.Product sticky init): above 769px the shorter of media group / buy box gets
     Debutify's sticky classes (skin CSS: position sticky, top 0), so it stays in view while the other scrolls */
  const STICKY = ['large--sticky', 'medium--sticky', 'sticky-check-header'];
  const small = matchMedia('screen and (max-width: 769px)');
  $$('[id^="ProductMediaGroup-"]').forEach((media) => {
    const meta = document.getElementById(media.id.replace('ProductMediaGroup-', 'ProductMeta-'));
    if (!meta) return;
    const set = () => {
      media.classList.remove(...STICKY); meta.classList.remove(...STICKY);
      if (small.matches) return;
      const hm = media.offsetHeight, hb = meta.offsetHeight;
      if (hb < hm) meta.classList.add(...STICKY); else if (hm < hb) media.classList.add(...STICKY);
    };
    set();
    addEventListener('load', set);
    small.addEventListener('change', set);
    new MutationObserver(set).observe(meta, { childList: true, subtree: true });   // Kaching renders into the buy box after load
  });

  /* sticky add-to-cart (live StickyAddtocart): once the main button has scrolled out above the viewport the bar gets
     sa-visible (skin: fadeInUp) and body scroll-sticky_addtocart; scrolling back up plays is-closing (fadeOutDown, 600ms), then hides.
     The button's position is read on every scroll (live measures once, before Kaching renders above it, so it showed too early) */
  const bar = $('.dbtfy-sticky_addtocart #stickyAddToCart');
  const mainBtn = $('.product-single__add-to-cart [type="submit"]');
  if (bar && mainBtn) {
    let shown = false, closing;
    const onScroll = () => {
      if (mainBtn.getBoundingClientRect().bottom < 0) {
        if (shown) return;
        shown = true; clearTimeout(closing); bar.classList.remove('is-closing');
        bar.classList.add('sa-visible'); body.classList.add('scroll-sticky_addtocart');
      } else if (shown) {
        shown = false; bar.classList.add('is-closing');
        closing = setTimeout(() => { bar.classList.remove('is-closing', 'sa-visible'); body.classList.remove('scroll-sticky_addtocart'); }, 600);
      }
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  $$('[data-sl-sticky-atc]').forEach((b) => b.addEventListener('click', () => {
    const btn = $('.product-single__add-to-cart [type="submit"]');
    if (btn) btn.click();
  }));
})();
